import { useState } from "react";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import "./RegMap.css";

const RegMap = () => {
  const containerStyle = { width: "100%", height: "500px" };
  const center = { lat: 25.26126, lng: 55.32754 };

  const locations = [
    {
      id: 1,
      name: "Good Hand Businessmen Services",
      position: { lat: 25.26126, lng: 55.32754 },
      labelClass: "label-left",
    },
    {
      id: 2,
      name: "Amer Center - Good Hand Government Transactions LLC",
      position: { lat: 25.26119, lng: 55.32748 },
      labelClass: "label-right",
    },
    {
      id: 3,
      name: "Al Adheed - Good Hand First Government Services (Authorized by Dubai Courts)",
      position: { lat: 25.26113, lng: 55.3274 },
      labelClass: "label-down",
    },
  ];

  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <div className="container-fluid p-0 regMainMap">
      <LoadScript
        googleMapsApiKey="AIzaSyBhxRitKE353P3AcgffuOJ6TjRgSfYAs1M"
        onLoad={() => setMapLoaded(true)}
      >
        {mapLoaded && (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={19}
            options={{
              disableDefaultUI: true,
              //   mapTypeId: "satellite",
              zoomControl: true,
              styles: [
                { featureType: "poi", stylers: [{ visibility: "off" }] },
                { featureType: "transit", stylers: [{ visibility: "off" }] },
              ],
            }}
          >
            {locations.map((loc) => (
              <MarkerF
                key={loc.id}
                position={loc.position}
                icon={{
                  url: "https://goodhand.b-cdn.net/Assets/Registration/mapico3.svg",

                  labelOrigin: new window.google.maps.Point(20, -20),
                }}
                label={{
                  text: loc.name,
                  className: `regMapLabel ${loc.labelClass}`,
                }}
              />
            ))}
          </GoogleMap>
        )}
      </LoadScript>
    </div>
  );
};

export default RegMap;
